import dateFormat from 'vux/src/tools/date/format.js'

import axios from 'axios'
import newApi from "../../fetch/newApi";
import sdk from "../../plugins/sdk/sdk";
export default {
/**
* 获取链接参数值
* name - 参数名称
*/
getQueryString: function (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
var r = window.location.search.substr(1).match(reg)

if (r != null) {
var value = r[2]
value = value.replace(/(%22|%3E|%3C|<|>)/g, 'MM')
if (value === '') { // 此处为安卓下浏览器的一个坑，匹配正则有区别
return null
} else {
return decodeURIComponent(value)
}
} else {
return null
}
},
/**
*var testDate = new Date( 1320336000000 );//这里必须是整数，毫秒
*var testStr = testDate.format("yyyy年MM月dd日hh小时mm分ss秒");
*var testStr2 = testDate.format("yyyyMMdd hh:mm:ss");
*/
dateConverter: function (formatData, timestamp) {
if (!Date.prototype.format) {
/* eslint-disable*/
Date.prototype.format = function (format) {
var o = {
'M+': this.getMonth() + 1, // month
'D+': this.getDate(), // day
'H+': this.getHours(), // hour
'm+': this.getMinutes(), // minute
's+': this.getSeconds(), // second
'q+': Math.floor((this.getMonth() + 3) / 3), // quarter
'S': this.getMilliseconds() // millisecond
}

if (/(Y+)/.test(format)) {
format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
}

for (var k in o) {
if (new RegExp('(' + k + ')').test(format)) {
format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
}
}
return format
}
}

var timestampStr = String(timestamp)
if(timestampStr.indexOf('.') !== -1) {
var dates = timestampStr.split('.')
var timeFormat = new Date(dates[0].replace(/-/g, "/"))
} else if(timestampStr.indexOf('-') !== -1) {
var timeFormat = new Date(timestampStr.replace(/-/g, '/'))
} else {
var timeFormat = new Date(timestamp)
}
return timeFormat.format(formatData)
},

handleNewDate: function (date) {
var dates = date.split('.')
return new Date(dates[0].replace(/-/g, "/"))
},

getTheDate: function (date, day) {

var a = date === '' ? new Date() : new Date(date)
a = a.valueOf()
a = a - day * 24 * 60 * 60 * 1000
a = new Date(a)
var m = a.getMonth() + 1
if (m.toString().length === 1) {
m = '0' + m
}
var d = a.getDate()
if (d.toString().length === 1) {
d = '0' + d
}
return a.getFullYear() + '-' + m + '-' + d
},
/**
* 格式化数字，如120000 => 12w 或 246000 => 24.6万
* 过滤器用法: {{ 120000 | formatCount}} -> 过滤为12w，{{ 120000 | formatCount('1')}} -> 过滤为12万
* @param {String} num - 数字
* @param {String} [type='0'] - type='0',则最后返回为'w';type='1',返回'万';默认为'0'
*
*/
formatCount: function (num, type='0') {
if(parseFloat(num) >= 10000) {
switch(type) {
case '0':
return (num/10000).toFixed(1) + "w"
case '1':
return (num/10000).toFixed(1) + "万"
default:
return
}
} else {
return num
}
},
/**
* 获取两个日期之间的时间差
* @param {String|Date} startTime - 开始时间, 如果传''，则默认为当前时间
* @param {String|Date} endTime - 结束时间，如果传''，则默认为当前时间
* @param {String} [type='0'] - '0':开始时间和结束时间类型都为字符串
* @returns {Object} - countDownArr，该对象里面包含了两个时间距离的天数，小时数、分钟数和秒数
*/
countDown: function (startTime, endTime, type='0') {
if (startTime !== '' && typeof startTime === 'string' && startTime.indexOf('-') !== -1) {
startTime = startTime.replace(/-/g, '/')
}

if (endTime !== '' && typeof endTime === 'string' && endTime.indexOf('-') !== -1) {
endTime = endTime.replace(/-/g, '/')
}

if (type === '0') {
if(startTime === '') {
var leftTime = (new Date(endTime)) - (new Date()) 
} else if(endTime === '') {
var leftTime = (new Date()) - (new Date(startTime)) 
} else {
var leftTime = (new Date(endTime)) - (new Date(startTime)) 
}
var countDownArr = {} 
countDownArr.days = parseInt(leftTime / 1000 / 60 / 60 / 24 , 10) 
countDownArr.hours = parseInt(leftTime / 1000 / 60 / 60 % 24 , 10) 
countDownArr.minutes = parseInt(leftTime / 1000 / 60 % 60, 10) 
countDownArr.seconds = parseInt(leftTime / 1000 % 60, 10) 
return countDownArr
}
},

getDateNext: function (date, type) {
var a = date === '' ? new Date() : new Date(date)
var aTime = a.getTime()
var cz = null
var timeObj = {}
if (type === 'before') {
cz = aTime - 3600 * 24 * 1000
} else {
cz = aTime + 3600 * 24 * 1000
}

timeObj = this.formattingTimeFn(cz)
return timeObj
},

formattingTimeFn: function (date) {
var a = date === '' ? new Date() : new Date(date)
var newTime = new Date(a)
var year = newTime.getFullYear()
var month = (newTime.getMonth() + 1) < 10 ? '0' + (newTime.getMonth() + 1).toString() : (newTime.getMonth() + 1)
var day = newTime.getDate() < 10 ? '0' + newTime.getDate().toString() : newTime.getDate()
var hours = newTime.getHours() < 10 ? '0' + newTime.getHours().toString() : newTime.getHours()
var minutes = newTime.getMinutes() < 10 ? '0' + newTime.getMinutes().toString() : newTime.getMinutes()
var seconds = newTime.getSeconds() < 10 ? '0' + newTime.getSeconds().toString() : newTime.getSeconds()

return {
y: year,
m: month,
d: day,
h: hours,
mm: minutes,
s: seconds,
date: year + '-' + month + '-' + day,
time: hours + ':' + minutes + ':' + seconds,
text: year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds,
stamp: newTime
}
},

dateContrastHandle (startTime, nowTime, type) {
const _type = type || null
const startDate = dateFormat(new Date(startTime), 'YYYY-MM-DD')
const nowDate = dateFormat(new Date(nowTime), 'YYYY-MM-DD')
const czObj = this.countDown(nowDate, startDate)

if (startDate.split('-')[0] - nowDate.split('-')[0] !== 0) {
return dateFormat(new Date(startTime), 'YYYY-MM-DD HH:mm')
}

if (czObj.days === 0) {
if (_type) {
return '今日 ' + dateFormat(new Date(startTime), 'HH:mm')
} else {
return dateFormat(new Date(startTime), 'HH:mm')
}
} else if (czObj.days === 1) {
return '明天 ' + dateFormat(new Date(startTime), 'HH:mm')
} else if (czObj.days === -1) {
if (_type) {
return '昨日 ' + dateFormat(new Date(startTime), 'HH:mm')
} else {
return dateFormat(new Date(startTime), 'MM-DD HH:mm')
}
} else {
return dateFormat(new Date(startTime), 'MM-DD HH:mm')
}
},
/**
* 格式化手机号，返回123****1234
* 过滤器用法: {{ 12345678901 | formatPhone}} -> 过滤为123****8901
* @param {String}  param - 手机号
* @returns {String} - 返回格式化之后的字符串
*/
formatPhone (param) {
var reg = /^(\d{3})[\s\S]+(\d{4})$/
var value
value = param.toString().replace(reg, '$1****$2')
return value
},
/**
* 是否为空对象
* @param {Object}  obj - 要判断的参数
* @returns {Boolean}
*/
isEmptyObject (obj) {
for (let key in obj) {
return false
}
return true
},
/**
* 把数字或者字符串9->09
* 过滤器用法：{{ 9 | formatZero }} -> 09
* @param {String|Number} num 要加0的数字
* @returns {String|Number}
*/
formatZero (num) {
if(Number(num) < 10 && Number(num) >= 0) {
return '0' + num
}
return num
},
/**
* 课程信息过滤器
* 过滤器用法：{{ 0 | formatCourseInfo }} -> 普通
* @param {Number} param  格式化参数
* @param {String}  type  格式化类型
* 参数type说明：
*    默认：'type',   课程分类 0-普通，1-直播，2-约课
*    'level',      课程级别 0-入门 1-进阶 2-高级
*    'content_type',   课程内容分类 1-技术分析 2-价值分析 3-量化分析 4-理论分析
* @returns {String}
*/
formatCourseInfo (param, type='type') {
switch (type) {
case 'type':
if (param === 0) return '普通'
if (param === 1) return '直播'
if (param === 2) return '约课'
break
case 'level':
if (param === 0) return '入门'
if (param === 1) return '进阶'
if (param === 2) return '高级'
break
case 'content_type':
if (param === 1) return '技术分析'
if (param === 2) return '价值分析'
if (param === 3) return '量化分析'
if (param === 4) return '理论分析'
break
default:
return ' '
}
return ' '
},

isPoneAvailable (pone) {
const myreg = /^[1][3,4,5,7,8][0-9]{9}$/
if (!myreg.test(pone)) {
return false;
} else {
return true;
}
},
/**
* 判断课程是否已经过期，页面建议配合is_living===0使用
* @param {String} param 直播课程的end_time
* @returns {Boolean}
*/
isFinishLiving (param) {

let endTime = param.replace(/\.0/, '')
let dateObj = this.countDown('', endTime)
if (
dateObj.days < 0 ||
dateObj.hours < 0 ||
dateObj.minutes < 0 ||
dateObj.seconds < 0
) {

return true
} else {

return false
}
},
/**
* 判断直播课程是否在当天
* @param {String} param 课程的start_time
* @returns {Boolean}
*/
isToday (param) {
return this.dateConverter('YYYY-MM-DD', param) === this.dateConverter('YYYY-MM-DD', new Date())
},

numberConvertUppercase (val) {
let arrs = {
1: '一',
2: '二',
3: '三',
4: '四',
5: '五',
6: '六',
7: '七',
8: '八',
9: '九',
10: '十',
11: '十一',
12: '十二',
13: '十三',
14: '十四',
15: '十五',
16: '十六',
17: '十七',
18: '十八',
19: '十九',
20: '二十',
21: '二十一',
22: '二十二',
23: '二十三',
24: '二十四',
25: '二十五',
26: '二十六',
27: '二十七',
28: '二十八',
29: '二十九',
30: '三十'
}
return arrs[val]
},

secondConvertTime (val) {
const newval = Number(val)
const hour = Math.floor(newval / 3600)
const min = Math.floor(newval / 60)
const s = newval % 60

return {
hour: hour,
minute: min,
second: s
}
},
/**
* 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
*
* @param  {function} func        传入函数
* @param  {number}   wait        表示时间窗口的间隔
* @param  {boolean}  immediate   设置为ture时，调用触发于开始边界而不是结束边界
* @return {function}             返回客户调用函数
*/
debounce:function(func, wait, immediate) {
var timeout, args, context, timestamp, result

var later = function() {

var last = new Date().getTime() - timestamp


if (last < wait && last > 0) {
timeout = setTimeout(later, wait - last)
} else {
timeout = null

if (!immediate) {
result = func.apply(context, args)
if (!timeout) context = args = null
}
}
}

return function() {
context = this
args = arguments
timestamp = new Date().getTime()
var callNow = immediate && !timeout

if (!timeout) timeout = setTimeout(later, wait)
if (callNow) {
result = func.apply(context, args)
context = args = null
}

return result
}
},

convertStrToDateTime: function (strTime) {
if (typeof strTime === 'number') {
strTime = strTime.toString();
}
var year = parseInt(strTime.slice(0, 4), 10);
var month = parseInt(strTime.slice(4, 6), 10) - 1;
var date = parseInt(strTime.slice(6, 8), 10);
var hours = parseInt(strTime.slice(8, 10), 10);
var minutes = parseInt(strTime.slice(10, 12), 10);
var seconds = parseInt(strTime.slice(12, 14), 10);
var d = new Date();
d.setFullYear(year);
d.setMonth(month);
d.setDate(date);
d.setHours(hours);
d.setMinutes(minutes);
d.setSeconds(seconds);
return d;
},

custormServiceStatus () {
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; 
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if (isAndroid) {
return 'android'
}
if (isiOS) {
return 'ios'
}
},

isVersionUpgrade (nowv, fnv) {
const _nsplit = nowv.split('.')
const _fsplit = fnv.split('.')


if (Number(_nsplit[0]) < Number(_fsplit[0])) {
return true
}

if (Number(_nsplit[0]) === Number(_fsplit[0])) {
if (Number(_nsplit[1]) < Number(_fsplit[1])) {
return true
}

if (Number(_nsplit[1]) === Number(_fsplit[1])) {
if (Number(_nsplit[2]) < Number(_fsplit[2])) {
return true
}
}
}

return false
},

/**
* 获取单个产品信息请求 - 复用频率较高，做提取
*
* @param {String} productCode
*/
ajaxProductInfo: function(productCode,successfn, errorfn) {
var data = {
productCode: productCode
}
return axios
.post(newApi.getAjaxUrl('payRead','getProductInfo'), data)
.then(res => {
successfn && successfn(res.data)
})
.catch(error => {
errorfn && errorfn(error)
})
},
/* 调起支付控件：h5  */
goPay: function(productCode, callBack) {
var that = this;
var from = that.getQueryString('dt_from') || 'app'
that.ajaxProductInfo(productCode,res=>{
var data = res.data
if(res.code == 0 && data && data.type != 3 && data.type != 4 // 排除付费专栏 文章
) {
callBack ? callBack() :
( location.href = newApi.getAjaxUrl('privi','getProductPay') +
'payment.html?webviewType=userActivitesType&dt_page_type=11&dt_from=' +
from + '&productCode=' + productCode );
}
})
},
versionPromise: null,
/**
* 获取带小数点版本号 2.10.1
*
* @change v2 20190916 xujb
*/
getVersion: function() {
let _this = this
var value = null; 
if (!_this.versionPromise) {
_this.versionPromise = new Promise(function (resolve,reject) {
sdk.beacon.getAccountInfo({}, function(accountInfo) {
value = _this.convertVersionV2(accountInfo) || null; 
resolve(value);
});
})
}
return _this.versionPromise
},
/**
* 根据accountInfo同步获取版本
*
* @param {Object}} accountInfo
*
* @author xujb 20190918
*/
convertVersionV2: function(accountInfo) {
let _this = this
return accountInfo['version'] || _this.convertVersion(accountInfo['DUA']);
},
/**
* 处理dua返回版本号
* @param DUA
* @returns {string}2.9.0
*/
convertVersion:function (DUA) {
var value = 0; 


var DUA = decodeURIComponent(DUA);
var isV2 = /APPVN/.test(DUA);
var paramName = isV2 ? 'APPVN' : 'VN';
var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)", "i");
var r = DUA.match(reg);
if (r != null) {
value = isV2 ? r[2] : r[2].substr(0, 3).split('').join('.');
}
return value;
},
/**
* 判断当前版本号是否高于或者等于指定版本
* @param {String/Number} limitVersion  比较版本号  2.6.0/260
* @param {String/number} nowVersion   当前版本号  2.6.0/260
* @param {Number} versionNumber   版本号比较位数   默认3位
*/
judgeVersionEnough: function(limitVersion, nowVersion, versionNumber) {
return this.versionCompare(nowVersion, limitVersion);
},
/**
* 版本号比较，curVer >= limitVer则true, 否则false
*
* @param {String|Number} curVer  当前版本 '2.10.0'|260(老版本兼容)
* @param {String|Number} limitVer  限制版本 同上
*/
versionCompare: function(curVer, limitVer){

if(!curVer) {
console.warn('当前版本号为空');
return false
}
if(!limitVer) {
console.warn('限制版本号为空');
return true
}

if(curVer == limitVer)
return true


curVer = String(curVer);
limitVer = String(limitVer);

var vCurVer = curVer.split(curVer.indexOf('.') != -1 ? '.' : ''),
vLimitVer = limitVer.split(limitVer.indexOf('.') != -1 ? '.' : ''),
iMaxLen = Math.max(vCurVer.length, vLimitVer.length),
pos = 0, // 下标
diff, // 差值
val1, val2;

while(pos < iMaxLen || pos < 10) {
val1 = parseInt(vCurVer[pos] || 0); 
val2 = parseInt(vLimitVer[pos] || 0);
diff = val1 - val2;
if(diff != 0 ) break;
pos++;
}

return diff >= 0;
},

urlReplace (url) {
return url.replace(/investor-education-wechat/, 'investor-education-manager')
}
}



// WEBPACK FOOTER //
// ./src/plugins/util/index.js